import { IconButton, Menu, MenuItem, Tooltip } from '@mui/material';
import { Language } from '@mui/icons-material';
import { useState } from 'react';
import { useLanguages } from '../../../hooks/use-languages';
import { useTranslation } from 'react-i18next';

export const LayoutLanguageSelector = () => {
  const { t, i18n } = useTranslation();
  const [langAnchorEl, setLangAnchorEl] = useState<null | HTMLElement>(null);
  const { languages } = useLanguages();

  const handleLangMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setLangAnchorEl(event.currentTarget);
  };

  const handleLangMenuClose = () => {
    setLangAnchorEl(null);
  };

  const handleLanguageChange = (lang: string) => {
    i18n.changeLanguage(lang);
    handleLangMenuClose();
  };

  return (
    <>
      <Tooltip title={t('theme.changeLanguage')}>
        <IconButton color="inherit" onClick={handleLangMenuOpen}>
          <Language />
        </IconButton>
      </Tooltip>

      <Menu anchorEl={langAnchorEl} open={Boolean(langAnchorEl)} onClose={handleLangMenuClose} disableScrollLock={true}>
        {languages.map((lang) => (
          <MenuItem key={lang.value} onClick={() => handleLanguageChange(lang.value)}>
            {lang.icon && (
              <span style={{ display: 'inline-flex', alignItems: 'center', marginRight: 8 }}>{lang.icon}</span>
            )}
            {lang.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
